import { Box } from 'braid-design-system';
import React from 'react';

import { SkeletonBlock } from '../SkeletonBlock/SkeletonBlock';

import { SkeletonUserRow } from './SkeletonUserRow/SkeletonUserRow';

export const SkeletonUserList = () => (
  <Box aria-label="Loading">
    <Box marginBottom="small">
      <SkeletonBlock variant="blue" width="xsmall" height="standard" />
    </Box>
    <Box style={{ height: '35px', marginBottom: '4px' }} background="surface" />
    {[1, 2, 3, 4, 5].map((i) => (
      <SkeletonUserRow key={i} />
    ))}
  </Box>
);
